import { InitCookie } from '@patsnap/init-cookie';

export class InitCookieService {
  getEntryChannel() {
    return 'agent_home';
  }

  setCampaignNameCookie() {
    // For hash-based routing (e.g., Vue Router in hash mode)
    // The query string is part of the hash fragment
    const hash = window.location.hash; // "#/agent/formulation?from=123"
    const queryIndex = hash.indexOf('?');

    let fromValue = null;
    if (queryIndex !== -1) {
      const queryString = hash.substring(queryIndex); // "?from=123"
      const urlParams = new URLSearchParams(queryString);
      fromValue = urlParams.get('from');
    }

    // Set the cookie if 'from' parameter exists
    if (fromValue) {
      document.cookie = `campaign_name=${encodeURIComponent(fromValue)}; path=/; max-age=2592000`;
    }
  }

  async init() {
    this.setCampaignNameCookie();
    const entry_channel = this.getEntryChannel();
    if (entry_channel) {
      const cookie = new InitCookie({
        entry_channel,
      });
      return await cookie.init();
    }
  }
}

export const initCookieService = new InitCookieService();
